import React, { ReactNode } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { LocalLoading } from "source/components/framework/Loading/LocalLoading/LocalLoading";

interface IListDetailsPanelAccordionProps {
    title: string | ReactNode;
    subTitle?: string;
    buttons?: ReactNode;
    children: ReactNode;
    isLoading?: boolean;
}

export const ListDetailsPanelAccordion = (props: IListDetailsPanelAccordionProps) => {
    return (
        <Accordion elevation={0} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ borderLeft: "none" }}>
                <Box display="flex" justifyContent="space-between" color="#616d7c" width="100%">
                    <Box display="flex" alignItems="center">
                        {props.title}
                        {props.subTitle &&
                            <Typography variant="caption" sx={{ marginLeft: "10px", marginTop: "1px" }}>{props.subTitle}</Typography>
                        }
                    </Box>
                    <Box sx={{ marginTop: "-9px", marginBottom: "-9px", marginRight: "5px" }}>
                        {!!props.isLoading &&
                            <LocalLoading />
                        }
                        {props.buttons}
                    </Box>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ paddingBottom: 0 }}>
                {props.children}
            </AccordionDetails>
        </Accordion>
    );
};
